import React from 'react';

const Logo = ({ 
  className = '', 
  width = 'auto', 
  height = '40px' 
}) => {
  return (
    <>
      {/* Square logo for mobile */}
      <img 
        src="/favicon.svg"
        alt="Remote Assistant AI - Partner Portal"
        className={`md:hidden ${className}`}
        style={{ width: height, height }}
      />
      {/* Full logo for desktop */}
      <img 
        src="/assets/logo.svg"
        alt="Remote Assistant AI - Partner Portal"
        className={`hidden md:block ${className}`}
        style={{ width, height }}
      />
    </>
  );
};

export default Logo;
